import { Typography } from '@mui/material';
import { MainPrice } from './main-price';
import { PriceTypes } from '@/models/catalog/course';
import type { Installment } from '@/models/catalog/offer';
import { formatMoney } from '@/utils/format-money';

interface SalePriceProps {
  salePrice: number | null;
  isIncluded: boolean;
  installment: Installment | null;
  installmentWithoutFee: Installment | null;
  type: PriceTypes;
}

export const SalePrice = ({
  salePrice,
  isIncluded,
  installment,
  installmentWithoutFee,
  type,
}: SalePriceProps) => {
  const showInstallmentInfo =
    installment &&
    type === PriceTypes.OneOff &&
    !isIncluded &&
    salePrice !== null &&
    salePrice > 0;

  return (
    <>
      <MainPrice
        salePrice={salePrice}
        isIncluded={isIncluded}
        installment={installment}
        type={type}
      />
      {showInstallmentInfo && (
        <Typography>
          {formatMoney(salePrice ?? 0)} à vista
          {installmentWithoutFee &&
            installment.max !== installmentWithoutFee.max && (
              <>
                <span> ou em até </span>
                <span>{installmentWithoutFee.max}x </span>
                <span> sem juros </span>
              </>
            )}
        </Typography>
      )}
    </>
  );
};
